import { Tooltip, Typography } from "@pankod/refine-antd";
import { HELIUM_LOGO_PATH, clearLocalSessionStorage } from "scripts/site";

export const AppTitle: React.FC = (params: any) => {
    return (
        <Tooltip title="Reload">
            <a href="/" onClick={() => clearLocalSessionStorage(false)}>
                <img
                    src={HELIUM_LOGO_PATH} alt={process.env.REACT_APP_ApplicationTitle}
                    className="app-title-small"
                />
                {params.collapsed
                    ? <></>
                    : <Typography.Text className="app-title">
                        Helium
                    </Typography.Text>
                }
            </a>
        </Tooltip>
    );
};